import { Link } from "react-router-dom";
import { SERVED_AREAS } from "../data/marketplace";
import { useLang, useT } from "../i18n";
import { ORGANIZATION_ID, absoluteUrl, breadcrumbLd, useSeo } from "../lib/seo";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

export default function ForCompanies() {
  const t = useT();
  const page = t.forCompanies;
  const lang = useLang();
  useSeo({
    title: t.seo.partners.title,
    fullTitle: true, // "… – LE COIN VTC" is part of the title
    description: t.seo.partners.description,
    ogTitle: t.seo.partners.ogTitle,
    ogDescription: t.seo.partners.ogDescription,
    path: "/partners",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Service",
        name: t.seo.partners.title,
        description: t.seo.partners.description,
        serviceType: "VTC vehicle rental marketplace",
        provider: { "@id": ORGANIZATION_ID },
        areaServed: { "@type": "AdministrativeArea", name: "Île-de-France" },
        url: absoluteUrl("/partners"),
        inLanguage: lang,
      },
      breadcrumbLd([[t.seo.breadcrumbHome, "/"], [t.seo.partners.title]]),
    ],
  });
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header activeHref="/partners" />

      <main className="flex-1">
        <section className="bg-ink px-4 py-16 text-center text-white sm:py-20">
          <div className="mb-3 text-xs text-dim">{page.eyebrow}</div>
          <h1 className="mx-auto m-0 max-w-160 text-2xl leading-tight font-medium text-balance sm:text-3xl">
            {page.title}
          </h1>
          <p className="mt-3.5 mb-7 text-[15px] text-dimmer">
            {page.subtitle}
          </p>
          <div className="flex flex-wrap justify-center gap-2.5">
            <Link
              to="/partners/signup"
              className="flex h-10 items-center rounded bg-brand px-5 text-[13px] font-medium text-white no-underline hover:bg-brand-dark"
            >
              {page.start}
            </Link>
            <Link
              to="/pricing"
              className="flex h-10 items-center rounded bg-white px-5 text-[13px] font-medium text-ink no-underline hover:bg-[#EDEDED]"
            >
              {page.pricing}
            </Link>
          </div>
        </section>

        <div className="mx-auto max-w-300 px-4 pt-9 pb-24 sm:px-6">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-4">
            {page.features.map((f) => (
              <div key={f.title} className="border-t-2 border-ink pt-3">
                <h2 className="m-0 mb-1.5 text-[15px] font-medium">{f.title}</h2>
                <p className="m-0 text-xs leading-relaxed text-muted">{f.text}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 grid items-center gap-5 rounded-lg bg-surface px-5 py-5 md:grid-cols-2 md:gap-8 md:py-6">
            <div>
              <h2 className="m-0 mb-1.5 text-lg font-medium">{page.notTitle}</h2>
              <p className="m-0 text-xs leading-relaxed text-muted">
                {page.notText}
              </p>
            </div>
            <div className="font-mono text-xs leading-[1.9] text-ink-soft" aria-label={page.areas}>
              {SERVED_AREAS.map((row) => (
                <div key={row.join()}>{row.join(" · ")}</div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
